import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { PointsAccountFacade } from '@features/points-account/facades/points-account/points-account.facade';
import { UserPreferenceFacade } from '@features/user-preference/facades/user-preference/user-preference.facade';
import { Store } from '@ngrx/store';
import { getLoyaltyCurrencySelected } from '@rd/core/loyalty-currency/store/selectors/loyalty-currency.selectors';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';
import { LoyaltyCurrency } from '@rd/types';
import { AnzAnalyticsService } from '@rd/wl/anz/services/analytics/analytics.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'anz-multi-card-select',
  templateUrl: './multi-card-select.component.html',
  styleUrls: ['./multi-card-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MultiCardSelectComponent implements OnInit {
  @HostBinding('class.anz-multi-card-select') componentClass = true;
  loyaltyCurrency$: Observable<LoyaltyCurrency | null>;

  constructor(
    public pointsAccountFacade: PointsAccountFacade,
    public userPreferenceFacade: UserPreferenceFacade,
    private store: Store,
    private anzAnalyticsService: AnzAnalyticsService,
    private pageTitleService: PageTitleService,
  ) {}

  ngOnInit(): void {
    this.loyaltyCurrency$ = this.store.select(getLoyaltyCurrencySelected);
    this.pageTitleService.setPageTitle('select-card');
    this.anzAnalyticsService.track({
      routeName: this.anzAnalyticsService.sitemap.selectCard,
    });
  }
}
